import {Box, Flex} from '@indoqa/style-system'
import {useQueryParam} from '@oegbv/ui-shared'
import * as React from 'react'
import {Button, Type} from '../../commons/components/button/Button'
import {FooterPanel} from '../../commons/components/footer/FooterPanel'
import {DigitalHelmet} from '../../commons/components/helmet/DigitalHelmet'
import {ContentLayout} from '../../commons/layouts/content-layout/ContentLayout'
import {DigitalHeaderPanel} from '../components/header/DigitalHeaderPanel'
import {digitalLoginPage, digitalQueryParams} from '../store/digital.paths'

export const DigitalSessionExpiredPage = () => {
  const redirectUri = useQueryParam(digitalQueryParams.redirect)
  const login = () => {
    window.location.href = digitalLoginPage(redirectUri)
  }

  const header = <DigitalHeaderPanel noSearch noLogin />
  const footer = <FooterPanel />
  return (
    <ContentLayout header={header} footer={footer} noFooterMarginTop>
      <DigitalHelmet canonical={digitalLoginPage()} />
      <Flex px={3} pt={16} center fullWidth direction="column">
        <Box>Ihre Benutzer-Session ist abgelaufen.</Box>
        <Box pt={8}>
          <Button linkTo={() => login()} text={`Login`} type={Type.LIGHT} />
        </Box>
      </Flex>
    </ContentLayout>
  )
}
